import React from 'react';
interface BeLogoProps {
  className?: string;
  variant?: 'navy' | 'white';
}
export const BeLogo = ({
  className = 'w-20 h-auto',
  variant = 'navy'
}: BeLogoProps) => {
  const src = variant === 'white' ? 'https://cdn.magicpatterns.com/uploads/7fpkFVRTm92CH7UjX68C3q/Be_Clinical_logo_white_hex.png' : 'https://cdn.magicpatterns.com/uploads/soLhM1KnSB6oBjbvH6KfQT/Be_Clinical_logo_navy_hex.png';
  return <img src={src} alt="Be Clinical" className={`${className} object-contain`} data-id="element-31" />;
};